import { Button } from '@Components/button/button'
import { Header } from '@Components/header/header'
import { ImageBackgroundSection } from '@Components/image-background-section/image-background-section'

import ErrorIcon from '@Assets/icons/error.svg'

import './status-screen.scss'

const CLASS_NAME = 'error-page'

export const ErrorPage = () => {
  return (
    <div className={CLASS_NAME}>
      <Header title="Schedule an Appointment" />
      <section className={`${CLASS_NAME}__body`}>
        <ImageBackgroundSection backgroundUrl={''} className={`${CLASS_NAME}__background`}>
          <img src={ErrorIcon} />
          <p>Something went wrong.</p>
          <p>Please try again.</p>
          <Button
            onClick={() => {
              window.location.href = `/create${location.search}`
            }}>
            Retry
          </Button>
        </ImageBackgroundSection>
      </section>
    </div>
  )
}
